var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-notification',{staticClass:"asc-confirmation",attrs:{"definition":_vm.definition,"on-close":_vm.onClose,"on-toast-action":_vm.onToastAction}})}
var staticRenderFns = []

export { render, staticRenderFns }